<!--  -->
<template>
  <div class="template">
    <audio :src="audioSrc" id="audioPlayer"></audio>
    <!-- 音频播放模块 -->
    <div class="player-box">
      <div
        :class="['audio-left', playing ? 'play' : 'pause']"
        id="audioPlayer"
        @click="audioPlay"
        ref="audioRefs"
        :style="`background-color:${color}`"
      ></div>
      <!-- <div
          class="audio-left"
          id="audioPlayer"
          @click="audioPlay"
        ></div> -->
      <div class="audio-right">
        <!-- <p style="max-width: 536px;">Beta-B_Kan R. Gao.mp3</p> -->
        <div class="progress-bar-bg" id="progressBarBg" @click="progressBarBg">
          <span id="progressDot" :style="'left:' + dotLeft + '%'"></span>
          <div
            class="progress-bar"
            id="progressBar"
            :style="'width:' + barWidth + '%'"
          ></div>
        </div>
        <div class="audio-time flex center">
          <span class="audio-length-current" id="audioCurTime">{{
            audioCurTime
          }}</span>
          <span class="audio-length-total">{{ duration }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      // 音频播放
      duration: "00:00", //音频总时长
      audioCurTime: "00:00", //音频当前时间
      playing: false, //音频播放中的状态
      barWidth: 0, //已播放条的宽度值
      dotLeft: 0, //进度点的left值
      // 音频播放
    };
  },
  props: {
    audioSrc: {
      type: String,
      default: function () {
        return "";
      },
    },
    color: {
      type: String,
    },
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 点击进度条跳到指定点播放
    // PS：此处不要用click，否则下面的拖动进度点事件有可能在此处触发，此时e.offsetX的值非常小，会导致进度条弹回开始处
    progressBarBg(e) {
      let audio = document.getElementById("audioPlayer");
      if (!audio.paused || audio.currentTime != 0) {
        // let pgsWidth = $(".progress-bar-bg").width();
        let pgsWidth =
          document.getElementsByClassName("progress-bar-bg")[0].offsetWidth;
        let rate = e.offsetX / pgsWidth;
        audio.currentTime = audio.duration * rate;
        this.updateProgress(audio);
      }
    },
    // 鼠标拖动进度点时可以调节进度
    // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
    // 鼠标按下时
    progressDot(e) {
      let that = this;
      let audio = document.getElementById("audioPlayer");
      let dot = document.getElementById("progressDot");
      if (!audio.paused || audio.currentTime != 0) {
        let oriLeft = dot.offsetLeft;
        let mouseX = e.clientX;
        let maxLeft = oriLeft; // 向左最大可拖动距离
        let maxRight =
          document.getElementById("progressBarBg").offsetWidth - oriLeft; // 向右最大可拖动距离

        // 禁止默认的选中事件（避免鼠标拖拽进度点的时候选中文字）
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }

        // 禁止事件冒泡
        if (e && e.stopPropagation) {
          e.stopPropagation();
        } else {
          window.event.cancelBubble = true;
        }

        // 开始拖动
        document.onmousemove = function (e) {
          let length = e.clientX - mouseX;
          if (length > maxRight) {
            length = maxRight;
          } else if (length < -maxLeft) {
            length = -maxLeft;
          }
          let pgsWidth =
            document.getElementsByClassName("progress-bar-bg")[0].width;
          let rate = (oriLeft + length) / pgsWidth;
          audio.currentTime = audio.duration * rate;
          that.updateProgress(audio);
        };

        // 拖动结束
        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    },
    // 音频播放停止事件
    audioPlay() {
      let that = this;
      let audio = document.getElementById("audioPlayer");
      // 监听音频播放时间并更新进度条
      audio.addEventListener(
        "timeupdate",
        function () {
          that.updateProgress(audio);
        },
        false
      );

      // 监听播放完成事件
      audio.addEventListener(
        "ended",
        function () {
          that.audioEnded();
        },
        false
      );

      // 改变播放/暂停图片
      if (audio.paused) {
        // 开始播放当前点击的音频
        audio.play();
        that.playing = true;
      } else {
        audio.pause();
        that.playing = false;
      }
    },
    // 更新进度条与当前播放时间 audio - audio对象
    updateProgress(audio) {
      let value = audio.currentTime / audio.duration;
      this.barWidth = value * 100;
      this.dotLeft = value * 100;
      this.audioCurTime = this.transTime(audio.currentTime);
      this.duration = this.transTime(audio.duration);
    },
    /**
     * 音频播放时间换算
     * @param {number} value - 音频当前播放时间，单位秒
     */
    transTime(value) {
      let time = "";
      let h = parseInt(value / 3600);
      value %= 3600;
      let m = parseInt(value / 60);
      let s = parseInt(value % 60);
      if (h > 0) {
        time = this.formatTime(h + ":" + m + ":" + s);
      } else {
        time = this.formatTime(m + ":" + s);
      }

      return time;
    },

    /**
     * 格式化时间显示，补零对齐
     * eg：2:4  -->  02:04
     * @param {string} value - 形如 h:m:s 的字符串
     */
    formatTime(value) {
      let time = "";
      let s = value.split(":");
      let i = 0;
      for (; i < s.length - 1; i++) {
        time += s[i].length == 1 ? "0" + s[i] : s[i];
        time += ":";
      }
      time += s[i].length == 1 ? "0" + s[i] : s[i];

      return time;
    },
    //  播放完成时把进度调回开始的位置
    audioEnded() {
      this.barWidth = 0;
      this.dotLeft = 0;
      this.playing = false;
      this.audioCurTime = "00:00";
    },
    audioInit() {
      let that = this;
      let audio = document.getElementById("audioPlayer");
      if (this.audioSrc != "") {
        audio.load();
        audio.addEventListener("canplay", function () {
          //监听audio是否加载完毕，如果加载完毕，则读取audio播放时间
          that.duration = that.transTime(audio.duration);
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.audioInit();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
  <style lang='less' scoped>
//@import url(); 引入公共css类
.template {
  .player-box {
    margin: 0 auto;
    width: 90%;
    height: 100%;
    justify-content: space-between;
    border-radius: 0.6rem;
    // margin: 0.4rem auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    .audio-left {
      margin-top: 0.8rem;
      width: 3rem;
      height: 3rem;
      border-radius: 50%;
      margin-right: 0.2rem;
      position: relative;
      background-color: #36AF98;
      // background-image: linear-gradient(-42deg, #32be61 0%, #7af091 100%);

      background-size: 0.2rem 0.2rem;
      background-position: center;
      background-repeat: no-repeat;
      .audio-icon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .audio-left.play {
      background-image: url("./images/pause.png");
      background-size: 1rem 1rem;
    }
    .audio-left.pause {
      background-image: url("./images/play.png");
      background-size: 1rem 1rem;
    }
    #audioPlayer {
      cursor: pointer;
    }

    .audio-right {
      /* margin-right: 2%; */
      /* float: right; */
      flex: 1;
      width: 0;
      height: 100%;
      position: relative;
      top: 0rem;
      left: 2vw;
      // p {
      //   font-size: 15px;
      //   height: 35%;
      //   margin: 8px 0;

      //   /* 歌曲名称只显示在一行，超出部分显示为省略号 */
      //   overflow: hidden;
      //   white-space: nowrap;
      //   text-overflow: ellipsis;
      //   max-width: 243px;
      //   /* 要适配小屏幕手机，所以最大宽度先设小一点，后面js根据屏幕大小重新设置 */
      // }

      .progress-bar-bg {
        background-color: #ebebeb;
        position: relative;
        top: 0.2rem;
        left: 11vw;
        height: 4px;
        width: 50vw;
        cursor: pointer;
        border-radius: 2px;

        span {
          content: " ";
          border-radius: 50%;
          background-color: #fff;
          position: absolute;
          left: 0;
          top: -50%;
          cursor: pointer;
          z-index: 2;

          width: 0.28rem;
          height: 0.28rem;
          margin-top: -0.14rem;
          margin-left: -0.14rem;
          background-color: rgba(255, 255, 255, 1);
          box-shadow: 0rem 0.03rem 0.07rem 0rem rgba(0, 0, 0, 0.16);
        }

        .progress-bar {
          background-color: #66d42e;
          width: 0;
          height: 4px;
          // margin-top: -0.01rem;
          border-radius: 2px;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          z-index: 1;
        }
      }

      .audio-time {
        overflow: hidden;
        margin-top: 0.1rem;
        color: #999999;
        justify-content: space-between;
        // margin-top: 0.16rem;
        font-size: 10px;
        display: flex;
        align-items: center;
        position: absolute;
        top: -0.2rem;
        left: 0;
        width: 100%;
      }
    }
  }
}
</style>